module.exports = __webpack_public_path__ + "assets/img/A5-1.c8e58483.jpg";